import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import { Dispatch } from "redux";
import { CertificateStatusEnum } from "../../../common/enums/CertificateStatusEnum";
import { setActiveTab, setCurrentPage } from "../CertificateSlice";
import { TabItems } from "@hatch-digital-nl/abs-storybook/legacy";

interface Props {
    dispatch: Dispatch;
    employeeData?: EmployeeInterface;
    activeTab: string;
}

export const tabItems = (props: Props): TabItems[] => {
    const { dispatch, employeeData, activeTab } = props;

    const onTabClick = (status: string): void => {
        dispatch(setActiveTab(status));
        dispatch(setCurrentPage(1));
    };

    return [
        {
            title: "Actief",
            amount: employeeData?.certificate_totals?.active_count,
            isActive: activeTab === CertificateStatusEnum.ACTIVE,
            onClick: () => onTabClick(CertificateStatusEnum.ACTIVE),
        },
        {
            title: "Vervallen",
            amount: employeeData?.certificate_totals?.expired_count,
            isActive: activeTab === CertificateStatusEnum.EXPIRED,
            onClick: () => onTabClick(CertificateStatusEnum.EXPIRED),
        },
        {
            title: "Afgekeurd",
            amount: employeeData?.certificate_totals?.rejected_count,
            isActive: activeTab === CertificateStatusEnum.REJECTED,
            onClick: () => onTabClick(CertificateStatusEnum.REJECTED),
        },
        {
            title: "In behandeling",
            amount: employeeData?.certificate_totals?.pending_count,
            isActive: activeTab === CertificateStatusEnum.PENDING,
            onClick: () => onTabClick(CertificateStatusEnum.PENDING),
        },
    ];
};
